<template>
  <v-card class="v-card--wizard" elevation="12" max-width="400">
    <v-tabs ref="tabs" v-model="internalValue" background-color="grey lighten-5" color="white" grow slider-size="70">
      <v-tabs-slider class="mt-1" color="primary" />

      <v-tab v-for="(item, i) in items" :key="i" :ripple="false" :disabled="!availableSteps.includes(i)">
        {{ item }}
      </v-tab>
    </v-tabs>

    <div class="my-6" />

    <v-card-text>
      <v-tabs-items v-model="internalValue">
        <slot />
      </v-tabs-items>
    </v-card-text>

    <v-card-actions class="pa-4 pb-4">
      <v-btn class="white--text" color="grey darken-2" outlined min-width="125" @click="$emit('click:prev')">Anterior</v-btn>

      <v-spacer />

      <v-btn color="primary" min-width="100" :loading="loading" @click="$emit('click:next')">Resetar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable';

  export default {
    name: 'BaseResetMaterialWizard',

    mixins: [Proxyable],

    props: {
      availableSteps: {
        type: Array,
        default: () => []
      },
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['click:prev', 'click:next']
  };
</script>

<style lang="sass">
  .v-card--wizard
    overflow: visible

    .v-tabs-bar
      height: 56px
      padding: 0 8px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
